import { urlQueryParamsCreator } from '../client-api/query-params'

export interface GetHypothesesParams extends Partial<GetHypothesesQueryParams> {
  projectId: string
}

export interface GetHypothesisParams {
  projectId: string
  hypothesisId: string
}

export interface CreateHypothesisParams {
  projectId: string
}

export interface GetTaskHypothesisRecommendationsParams {
  projectId: string
  taskId: string
}

export interface GetHypothesesQueryParams {
  statusId: string | number
  toolId: string | number
  priorityId: string | number
  processStatus: string | number
  achivenmentStatus: string | number
  growthPointId: string | number
  markId: string | number
  markTypeId: string | number
  kindId: string | number
}

const endpoints = {
  getHypotheses: ({ projectId, ...queryParams }: GetHypothesesParams): string => {
    const params = urlQueryParamsCreator({
      status_id: queryParams?.statusId,
      tool_id: queryParams?.toolId,
      priority_id: queryParams?.priorityId,
      process_status: queryParams?.processStatus,
      is_success: queryParams?.achivenmentStatus,
      growth_point_id: queryParams?.growthPointId,
      mark_id: queryParams?.markId,
      mark_type_id: queryParams?.markTypeId,
      kind_id: queryParams?.kindId,
    })
    return `api/v2/users/user-id/projects/${projectId}/hypotheses/${params}`
  },
  getHypothesis: ({ projectId, hypothesisId }: GetHypothesisParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/hypotheses/${hypothesisId}`
  },
  update: 'api/hypothesis',
  create: ({ projectId }: CreateHypothesisParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/hypotheses`
  },
  getTaskHypothesisRecommendations: ({ projectId, taskId }: GetTaskHypothesisRecommendationsParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/tasks/${taskId}/hypothesis/recommendations`
  },
}

export default endpoints
